<template>
  <div class="animated revealUp">
    
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('edit') }} {{ $tc('backupsettings' , 1) }}</div>
      <router-link
        class="btn-blue"
        to="backup-settings"
      >{{ $tc('backupsettings' , 1) }} {{ $tc('list', 2) }}</router-link>
    </div>
    <div class="edit-movie-container">
      <div>
        <div class="row">
          <div class="col-6 mb-4">
            <div class="dropdown-curve-container">
              <label :class="selectedCinema.length > 0 ? 'shift-up' : '' ">Select Cinema</label>
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema);"
                  name="selectcinema"
                  id="selectcinema"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <p
              v-if="submitted && selectedCinema.length == 0"
              class="error_message"
            >{{ messagecinema }}</p>
          </div>

          <!-- <div class="col-md-6 mb-4">
            <div class="d-flex align-items-center">
              <label for="file-selector" class="file-selector w-100">
                <span>{{ item_image_url }}</span>
                <input
                  type="file"
                  v-on:change="uploadImage($event)"
                  name="file-selector"
                  id="file-selector"
                  class="d-none"
                />
              </label>
              <Tooltip :title="$t('backupSettingBackupLocationBrowse_tooltip')" />
            </div>
            <p
              v-if="submitted && item_image_url == 'Browse Backup Location'"
              class="error_message"
            >Please Select Backup Location.</p>
          </div>-->

          <div class="col-md-12 mx-auto px-3 mb-4">
            <h5 class="border-bottom pb-3">{{ $tc('backup', 2) }} {{ $tc('schedule', 2) }}</h5>
          </div>

          <div class="col-md-12 mb-4">
            <div class="row pb-3 border-bottom">
              <div class="col-md-7">
                <div class="d-flex align-items-center">
                  <div>{{ $t('daily') }}</div>
                </div>
              </div>
              <!-- {{ cronTimer.daily.time }} sssssss -->
              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <div class="input-container">
                    <input
                      :disabled="!schedule.daily"
                      v-model="cronTimer.daily.time"
                      type="text"
                      placeholder="19:00"
                      name="daily"
                      id="daily"
                    />
                  </div>
                  <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`clock.svg`" />
                </div>
                <p
                  v-if="submitted && selectedSchedule == 'daily' "
                  class="error_message"
                >{{ errmsg }}</p>
              </div>

              <div class="col-md-2">
                <div class="d-flex justify-content-center align-items-center">
                  <label class="ios-switch">
                    <input
                      id="name_1"
                      type="checkbox"
                      class="ios-checkbox"
                      v-on:change="onChangeStatus($event,'daily')"
                      v-model="schedule.daily"
                    />
                    <span class="switch-slider"></span>
                  </label>
                  <Tooltip :title="$t('backupSettingDaily_tooltip')" />
                </div>
              </div>
            </div>

            <div class="row py-3 border-bottom">
              <div class="col-md-4">
                <div class="d-flex">
                  <div>{{ $t('weekly') }}</div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <div class="dropdown-curve-container">
                    <label :class="selectedDay.length > 0 ? 'shift-up' : '' ">Select Day</label>
                    <b-dropdown
                      :disabled="!schedule.weekly"
                      :text="selectedDay"
                      variant="dropdown-curve"
                      class="w-100"
                    >
                      <b-dropdown-item
                        href="#"
                        v-for="(week, weekIndex) in cronTimer.weekly.weekArray"
                        :key="weekIndex"
                        v-on:click="onSelectDay($event, week,weekIndex);"
                        name="selectday"
                        id="selectday"
                      >{{ week }}</b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`school-calendar.svg`" />
                </div>
                <p
                  v-if="submitted && selectedSchedule == 'weekly'"
                  class="error_message"
                >{{ errmsg }}</p>
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <div class="input-container">
                    <input
                      :disabled="!schedule.weekly"
                      v-model="cronTimer.weekly.time"
                      type="text"
                      placeholder="19:00"
                      name="weeklyin"
                      id="weeklyin"
                    />
                  </div>
                  <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`clock.svg`" />
                </div>
                <p
                  v-if="submitted && selectedSchedule == 'weekly'"
                  class="error_message"
                >{{ errmsg }}</p>
              </div>

              <div class="col-md-2">
                <div class="d-flex justify-content-center align-items-center">
                  <label class="ios-switch">
                    <input
                      id="name_2"
                      type="checkbox"
                      class="ios-checkbox"
                      v-on:change="onChangeStatus($event,'weekly')"
                      v-model="schedule.weekly"
                    />
                    <span class="switch-slider"></span>
                  </label>

                  <Tooltip :title="$t('backupSettingWeekly_tooltip')" />
                </div>
              </div>
            </div>

            <div class="row py-3 border-bottom">
              <div class="col-md-4">
                <div class="d-flex align-items-center">
                  <div>{{ $t('fortnight') }}</div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <div class="d-flex align-items-center">
                      <!-- <div class="input-container">
                      <input
                        :disabled="!schedule.fortnight"
                        v-model="cronTimer.fortnight.startDate"
                        v-on:change="onChangeDate($event)"
                        type="date"
                        placeholder="01/06/2019"
                      />
                      </div>-->
                      <div class="input-material">
                        <div class="add-datepicker">
                          <button
                            class="btn-clearDate"
                            v-if="cronTimer.fortnight.startDate"
                            v-on:click="clearSelectedDate()"
                          >✖</button>
                          <Datepicker :monday-first="true"
                            :disabled="!schedule.fortnight"
                            ref="programaticOpen"
                            v-model="cronTimer.fortnight.startDate"
                            @selected="onChangeDate($event)"
                            name="fortnight_1"
                            id="fortnight_1"
                          ></Datepicker>
                          <label
                            :class="typeof cronTimer.fortnight.startDate === 'object' ? 'active': ''"
                          >Start Date</label>
                        </div>
                      </div>
                      <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`school-calendar.svg`" />
                    </div>
                    <p
                      v-if="submitted && selectedSchedule == 'fortnight'"
                      class="error_message"
                    >{{ errmsg }}</p>
                  </div>

                  <div class="col-md-6 mb-3">
                    <div class="d-flex align-items-center">
                      <!-- <div class="input-container">
                      <input
                        :disabled="!schedule.fortnight"
                        v-model="cronTimer.fortnight.startDate"
                        v-on:change="onChangeDate($event)"
                        type="date"
                        placeholder="01/06/2019"
                      />
                      </div>-->
                      <div class="input-material">
                        <div class="add-datepicker">
                          <button
                            class="btn-clearDate"
                            v-if="cronTimer.fortnight.endDate"
                            v-on:click="clearSelectedDate()"
                          >✖</button>
                          <Datepicker :monday-first="true"
                            :disabled="!schedule.fortnight"
                            ref="programaticOpen"
                            v-model="cronTimer.fortnight.endDate"
                            @selected="onChangeDate($event)"
                            name="fortnight_2"
                            id="fortnight_2"
                          ></Datepicker>
                          <label
                            :class="typeof cronTimer.fortnight.endDate === 'object' ? 'active': ''"
                          >End Date</label>
                        </div>
                      </div>
                      <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`school-calendar.svg`" />
                    </div>
                    <p
                      v-if="submitted && selectedSchedule == 'fortnight'"
                      class="error_message"
                    >{{ errmsg }}</p>
                  </div>

                  <div class="col-md-6">
                    <div class="d-flex align-items-center">
                      <div class="input-container">
                        <input
                          :disabled="!schedule.fortnight"
                          v-model="cronTimer.fortnight.startTime"
                          type="text"
                          placeholder="16:30"
                          name="fortnight_3"
                          id="fortnight_3"
                        />
                      </div>
                      <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`clock.svg`" />
                    </div>
                    <p
                      v-if="submitted && selectedSchedule == 'fortnight'"
                      class="error_message"
                    >{{ errmsg }}</p>
                  </div>

                  <div class="col-md-6">
                    <div class="d-flex align-items-center">
                      <div class="input-container">
                        <input
                          :disabled="!schedule.fortnight"
                          v-model="cronTimer.fortnight.endTime"
                          type="text"
                          placeholder="16:30"
                          name="fortnight_4"
                          id="fortnight_4"
                        />
                      </div>
                      <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`clock.svg`" />
                    </div>
                    <p
                      v-if="submitted && selectedSchedule == 'fortnight'"
                      class="error_message"
                    >{{ errmsg }}</p>
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <div class="d-flex justify-content-center align-items-center">
                  <label class="ios-switch">
                    <input
                      id="name_3"
                      type="checkbox"
                      class="ios-checkbox"
                      v-on:change="onChangeStatus($event,'fortnight')"
                      v-model="schedule.fortnight"
                    />
                    <span class="switch-slider"></span>
                  </label>

                  <Tooltip :title="$t('backupSettingFortnight_tooltip')" />
                </div>
              </div>
            </div>

            <div class="row py-3 border-bottom">
              <div class="col-md-4">
                <div class="d-flex">
                  <div>{{ $t('monthly') }}</div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <div class="input-container">
                    <input
                      :disabled="!schedule.monthly"
                      v-model="cronTimer.monthly.date"
                      type="text"
                      placeholder="31/06/2019"
                      name="monthly_1"
                      id="monthly_1"
                    />
                  </div>
                  <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`school-calendar.svg`" />
                </div>
                <p
                  v-if="submitted && selectedSchedule == 'monthly'"
                  class="error_message"
                >{{ errmsg }}</p>
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center">
                  <div class="input-container">
                    <input
                      :disabled="!schedule.monthly"
                      v-model="cronTimer.monthly.time"
                      type="text"
                      placeholder="23:30"
                      name="monthly_2"
                      id="monthly_2"
                    />
                  </div>
                  <Tooltip :title="`Select the folder where you want to store all backups for Cinematic`" 
                  :src="`clock.svg`" />
                </div>
                <p
                  v-if="submitted && selectedSchedule == 'monthly'"
                  class="error_message"
                >{{ errmsg }}</p>
              </div>

              <div class="col-md-2">
                <div class="d-flex justify-content-center align-items-center">
                  <label class="ios-switch">
                    <input
                      id="name_4"
                      type="checkbox"
                      class="ios-checkbox"
                      v-on:change="onChangeStatus($event,'monthly')"
                      v-model="schedule.monthly"
                    />
                    <span class="switch-slider"></span>
                  </label>

                  <Tooltip :title="$t('backupSettingMonthly_tooltip')" />
                </div>
              </div>
            </div>

            <div class="row py-3 border-bottom">
              <div class="col-md-4">
                <div class="d-flex">
                  <div>Auto</div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center"></div>
              </div>

              <div class="col-md-3">
                <div class="d-flex align-items-center"></div>
              </div>

              <div class="col-md-2">
                <div class="d-flex justify-content-center align-items-center">
                  <label class="ios-switch">
                    <input
                      id="name_5"
                      type="checkbox"
                      class="ios-checkbox"
                      v-on:change="onChangeStatus($event,'auto')"
                      v-model="schedule.auto"
                    />
                    <span class="switch-slider"></span>
                  </label>

                  <Tooltip :title="$t('backupSettingAuto_tooltip')" />
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="col-md-12 mx-auto px-3 mb-4">
          <h5 class="border-bottom pb-3">{{ $t('backuprestore') }}</h5>
          </div>-->

          <!-- <div class="col-md-6 mb-4">
          <div class="mb-1">
            <label>{{ $t('selectdateandtime') }}</label>
          </div>
          <div class>
            <b-dropdown text="Select Date & Time" variant="dropdown-curve" class="w-75">
              <b-dropdown-item href="#">Backup 1</b-dropdown-item>
              <b-dropdown-item href="#">Backup 2</b-dropdown-item>
            </b-dropdown>
            <p class="error_msg">{{ $t('titleempty') }}</p>
          </div>
          </div>-->

          <!-- <div class="col-md-12 mx-auto px-3 mb-4">
          <h5 class="border-bottom pb-3">{{ $t('howlongbackuptokeep') }}</h5>
          </div>-->

          <!-- <div class="col-md-6 mb-4">
          <div class="d-flex align-items-center">
            <b-dropdown text="Select" variant="dropdown-curve" class="w-75">
              <b-dropdown-item href="#">Select 1</b-dropdown-item>
              <b-dropdown-item href="#">Select 2</b-dropdown-item>
            </b-dropdown>
            <Tooltip :title="$t('backupSettingBackupToKeep_tooltip')" />
          </div>
          <p class="error_msg">{{ $t('titleempty') }}</p>
          </div>-->

          <div class="col-md-6 mb-4">
            <div class="row">
              <div class="col-md-3 col-xl-2">
                <label>{{ $t('active') }}</label>
              </div>
              <div class="col-md-9 col-xl-10">
                <div>
                  <label class="ios-switch">
                    <input type="checkbox" class="ios-checkbox" checked />
                    <span class="switch-slider"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12 text-center mt-4">
            <!-- <button
              @click.prevent.stop="onFinalSubmit(true)"
              class="btn-blue"
            >{{ $t('saveaddmore') }}</button>-->
            <button
              :disabled="btenable"
              @click.prevent.stop="onFinalSubmit(true)"
              class="btn-blue"
            >{{ $t('update') }}</button>
            <button @click.prevent.stop="onResetForm()" class="btn-black">{{ $t('reset') }}</button>
            <b-button
              class="btn-outline-grey"
              variant="default"
              to="backup-settings"
            >{{ $t('cancel') }}</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
// Main JS (in UMD format)
import CheckConnectionService from "@/services/CheckConnectionService.js";
// import VueTimepicker from "vue2-timepicker";

// CSS
// import "vue2-timepicker/dist/VueTimepicker.css";
export default {
  // components: {
  //   VueTimepicker
  // },
  data() {
    return {
      btenable: false,
      isRoleID: true,
      messagecinema: "Please Select Cinema.",
      messageday: "Please Select Day.",
      // item_image_url: "Browse Backup Location",
      errmsg: "",
      submitted: false,
      Cinemas: [],
      selectedCinema: "",
      selectedDay: "",
      cine_id: null,
      bs_id: null,
      selectedSchedule: "daily",
      schedule: {
        daily: true,
        weekly: false,
        fortnight: false,
        monthly: false,
        auto: false
      },
      cronTimer: {
        cine_id: null,
        daily: {
          time: ""
        },
        weekly: {
          day: "",
          time: "",
          weekArray: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thrusday",
            "Friday",
            "Saturday"
          ]
        },
        fortnight: {
          startDate: "",
          endDate: "",
          startTime: "",
          endTime: ""
        },
        monthly: {
          date: "",
          time: ""
        }
      }
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
  },
  mounted() {
    const { cinema_id, backup_id } = this.$route.query;
    if (cinema_id) {
      this.getCinemaList(cinema_id);
      this.bs_id = backup_id;
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    getCinemaList: function(cinema_id) {
      CinemasService.GetActiveCinemas({ activekey: "cine_is_active" })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map(x => {
              if (x.cine_id == cinema_id) {
                this.selectedCinema = x.cine_name;
                this.cine_id = x.cine_id;
              }
            });
            this.getCinemaBackupSettings(cinema_id);
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    getCinemaBackupSettings: function(cinema_id) {
      let payload = {
        cinema_id: cinema_id
      };
      CinemasService.ReadABackupSetting(payload)
        .then(response => {
          const { data } = response;
          console.log("data :", data);
          if (data && data.status) {
            console.log("data.Records[0] :", data.Records[0]);
            let obj = data.Records[0];
            Object.keys(this.schedule).map(x => {
              if (x !== obj.bt_type.toLowerCase()) {
                this.schedule[x] = false;
              } else {
                this.schedule[x] = true;
              }
              console.log("obj.bt_type :", obj.bt_type);
              if (obj.bt_type == "Daily") {
                this.cronTimer[obj.bt_type.toLowerCase()].time = obj.bs_time1;
                this.cronTimer.daily.time = obj.bs_time1;
              }
              if (obj.bt_type == "Weekly") {
                this.cronTimer[
                  obj.bt_type.toLowerCase()
                ].day = this.cronTimer.weekly.weekArray[obj.weekday_id];
                this.selectedDay = this.cronTimer.weekly.weekArray[
                  obj.weekday_id
                ];
                // console.log(
                //   "object :",
                //   this.cronTimer[obj.bt_type.toLowerCase()].day
                // );
              }
              if (obj.bt_type == "Fortnight" || obj.bt_type == "Monthly") {
                this.cronTimer[obj.bt_type.toLowerCase()].startDate =
                  obj.bs_date1;
                this.cronTimer[obj.bt_type.toLowerCase()].date = obj.bs_date1;
                this.cronTimer[obj.bt_type.toLowerCase()].endDate =
                  obj.bs_date2;
                this.cronTimer[obj.bt_type.toLowerCase()].endTime =
                  obj.bs_time2;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          this.$toasted.show(err);
        });
    },
    onSelectCinema: function(event, params) {
      this.selectedCinema = params.cine_name;
      // this.cronTimer.cine_id = params.cine_id;
      this.cine_id = params.cine_id;
    },
    onResetForm: function() {
      this.selectedCinema = "";
      this.schedule.daily = true;
      this.schedule.weekly = false;
      this.schedule.fortnight = false;
      this.schedule.monthly = false;
      this.schedule.auto = false;
      this.cronTimer.daily.time = "";
      this.cronTimer.weekly.day = "";
      this.cronTimer.weekly.time = "";
      this.cronTimer.fortnight.startDate = "";
      this.cronTimer.fortnight.endDate = "";
      this.cronTimer.fortnight.startTime = "";
      this.cronTimer.fortnight.endTime = "";
      this.cronTimer.monthly.time = "";
      this.cronTimer.monthly.date = "";
    },
    onSelectDay: function(event, day, dayIndex) {
      this.cronTimer.weekly.day = dayIndex;
      this.selectedDay = day;
    },
    // uploadImage: function(image) {
    //   let self = this;
    //   let formData = new FormData();
    //   formData.append("image", image.target.files[0]);
    //   formData.append("imagePath", "/uploads/fnb_item/");
    //   MasterService.GlobalUploadImage(formData)
    //     .then(response => {
    //       const { data } = response;
    //       data.message ? alert(data.message) : "";
    //       if (data.status) {
    //         self.item_image_url = data.path;
    //       }
    //       self.BaseURL = data.BaseURL;
    //     })
    //     .catch(error => {
    //       alert(
    //         "Sorry! Something went wrong. kindly contact your administrator"
    //       );
    //     });
    // },

    onFinalSubmit: function(flag) {
      this.submitted = true;
      console.log("this.selectedSchedule :", this.selectedSchedule);
      Object.keys(this.cronTimer[this.selectedSchedule]).map(x => {
        console.log("x :", x);
        if (this.cronTimer[this.selectedSchedule][x] == "") {
          this.errmsg = "Please enter manadatory fields.";
          return;
        } else {
          this.btenable = true;
          let payload = {
            filePath: this.filePath || "Downloads",
            cronDetails: this.cronTimer[this.selectedSchedule],
            scheduleType: this.selectedSchedule,
            backup_id: this.bs_id
          };
          payload.cronDetails["bs_id"] = this.bs_id;
          console.log("this.bs_id :", this.bs_id);
          CinemasService.UpdateABackupSetting(payload)
            .then(response => {
              this.btenable = false;
              // console.log("response :", response);
              const { data } = response;
              // console.log("data.Status 1 :", data.status);
              if (data.status === true) {
                // console.log("data.Status 2 :", data.status);
                this.onResetForm();
                if (flag) {
                  this.$router.push({
                    path: "backup-settings"
                  });
                } else {
                  // console.log("data.message 1:", data.message);
                  this.$toasted.show(data.message);
                }
              } else {
                // console.log("data.message 2:", data.message);
                this.$toasted.show(data.message);
              }
            })
            .catch(error => {
              this.$toasted.show(error);
            });
        }
      });
    },

    onChangeDate: function(e) {
      var dateObject = e;
      var numberOfDaysToAdd = 15;
      dateObject.setDate(dateObject.getDate() + numberOfDaysToAdd);

      var dd = dateObject.getDate();
      var mm = dateObject.getMonth() + 1;
      var y = dateObject.getFullYear();

      this.cronTimer.fortnight.endDate = dd + "/" + mm + "/" + y;
    },
    onChangeStatus: function(event, name) {
      this.selectedSchedule = name;
      Object.keys(this.schedule).map(x => {
        if (x !== name) {
          this.schedule[x] = false;
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/BackupSettingComponent/editBackupSettings.vue